import { render, staticRenderFns } from "./jt808-serv-combine-orders.vue?vue&type=template&id=996e8026&scoped=true"
import script from "./jt808-serv-combine-orders.vue?vue&type=script&lang=js"
export * from "./jt808-serv-combine-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996e8026",
  null
  
)

export default component.exports